import React from 'react';
import { User, Users, Home } from 'lucide-react';

interface TravelerInfo {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
}

interface RoomPreference {
  type: string;
  quantity: number;
}

interface TravelersRoomPreferencesProps {
  travelers: TravelerInfo[];
  roomPreferences: RoomPreference[];
}

export default function TravelersRoomPreferences({ travelers, roomPreferences }: TravelersRoomPreferencesProps) {
  // Fonction pour obtenir le nom du type de chambre
  const getRoomTypeName = (type: string) => {
    const types = {
      'SINGLE': 'Simple',
      'DOUBLE': 'Double',
      'TRIPLE': 'Triple',
      'SUITE': 'Suite'
    };
    return types[type as keyof typeof types] || type;
  };
  
  return (
    <div className="space-y-6">
      {/* Voyageurs */}
      <div>
        <h4 className="text-md font-medium mb-2 flex items-center">
          <Users className="w-4 h-4 mr-2" />
          Voyageurs ({travelers.length})
        </h4>
        <div className="bg-white rounded-lg border divide-y">
          {travelers.map((traveler, index) => (
            <div key={`traveler-${index}`} className="p-3">
              <p className="font-medium">{traveler.firstName} {traveler.lastName}</p>
              <p className="text-sm text-gray-500">{traveler.email}</p>
              <p className="text-sm text-gray-500">{traveler.phone || 'Pas de téléphone'}</p>
            </div>
          ))}
        </div>
      </div>
      
      {/* Préférences de chambres */}
      <div>
        <h4 className="text-md font-medium mb-2 flex items-center">
          <Home className="w-4 h-4 mr-2" />
          Préférences de chambres
        </h4>
        <div className="bg-white rounded-lg border divide-y">
          {roomPreferences.map((room, index) => (
            <div key={`room-${index}`} className="p-3 flex justify-between items-center">
              <p className="font-medium">
                Chambre {getRoomTypeName(room.type)}
              </p>
              <p className="text-sm bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                {room.quantity} chambre(s)
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
} 